import { Component, Input } from '@angular/core';

export type EntityInfoCardVariant =
  | 'success'
  | 'danger'
  | 'error'
  | 'warning'
  | 'info'
  | 'muted';

@Component({
  selector:
    'hospitality-bot-entity-info-card, hospitality-bot-guest-info-card',
  templateUrl: './entity-info-card.component.html',
  styleUrls: ['./entity-info-card.component.scss'],
})
export class EntityInfoCardComponent {
  @Input() variant: EntityInfoCardVariant = 'success';
  @Input() icon?: string;
  @Input() label?: string;
  @Input() value?: string;
  @Input() subValue?: string;
  @Input() description?: string;

  get resolvedVariant(): string {
    if (this.variant === 'error') return 'danger';
    return this.variant || 'success';
  }

  get resolvedIcon(): string {
    if (this.icon) return this.icon;
    switch (this.resolvedVariant) {
      case 'danger':
        return 'pi pi-exclamation-circle';
      case 'warning':
        return 'pi pi-exclamation-triangle';
      case 'info':
      case 'muted':
        return 'pi pi-info-circle';
      case 'success':
      default:
        return 'pi pi-check-circle';
    }
  }
}
